import * as React from 'react';
import {useState,useEffect,useRef,useContext} from 'react'
import { Box,Tabs,Tab,Divider,Tooltip,Typography } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';
import DescriptionIcon from '@mui/icons-material/Description';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import {useTheme} from "@mui/material";
import { styled } from '@mui/material/styles';
import GridViewIcon from '@mui/icons-material/GridView';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import HorizontalSplitIcon from '@mui/icons-material/HorizontalSplit';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { CHART_SCREEN_TYPE, CHART_TYPE } from '../../../common/utility/mp_chart_constants';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MIN_WIDTH_3_COLS, USER_ROLE_FIELDS, USER_RESOURCES_LIST } from '../../../common/utility/constant';
import AppErrorPopup from '../../../components/AppErrorPopup';
// ============================================================
// NEW - Role-based Permission System
// See: src/common/utility/roleController.js
// ============================================================
import { useRoleController } from '../../../common/utility/roleController';
import { ROLES } from '../../../common/utility/roleConstants';
import { TEXT_MSGS } from '../../../common/utility/constant';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import Save from '@mui/icons-material/Save';
import useAuth from '../../../common/hooks/useAuth';
import WatchLaterIcon from '@mui/icons-material/ListAlt';
// import { Typography } from 'antd';
import { fontSize, textAlign } from '@mui/system';
import usePermissions from '../../../common/hooks/usePermissions';

const StyledTabs = styled((props) => (
    <Tabs
      {...props}
      sx={{padding:"0px"}}
      TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
  ))({
    '& .MuiTabs-indicator': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
      maxWidth: 0,
      width: '0%',
      backgroundColor: '#635ee7',
    },
  });
  
  const StyledTab = styled((props) => <Tab sx={{minWidth:'50px',maxHeight:"60px",paddingBottom:0}} disableRipple {...props} />)(
    ({ theme }) => ({
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(10),
      marginRight: theme.spacing(1),
      color: 'rgba(255, 255, 255, 0.7)',
      '&.Mui-selected': {
        color: '#fff',
        backgroundColor:`${theme.palette.primaryTheme.shade03}`
      },
      '&.Mui-focusVisible': {
        backgroundColor: 'rgba(100, 95, 228, 0.32)',
      },
    }),
  );

  const StyledTabMultiChart = styled((props) => <Tab sx={{minWidth:'50px'}} disableRipple {...props} />)(
    ({ theme }) => ({
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(10),
      marginRight: theme.spacing(1),
      color: 'rgba(255, 255, 255, 0.7)',
      '&.Mui-selected': {
        color: '#fff',
        backgroundColor:`${theme.palette.primaryTheme.shade03}`
      },
      '&.Mui-focusVisible': {
        backgroundColor: 'rgba(100, 95, 228, 0.32)',
      },
    }),
  );
export default function MPChartRightPanel(props) {
  const theme=useTheme();  
  const [value, setValue] = React.useState(false);
  const [screenId, setScreenId] = React.useState(props.chartScreenType);
  const matches = useMediaQuery('(min-width:640px)');   //use to detect if device is tablet or desktop
  const matchesBigscreen = useMediaQuery(`(min-width:${MIN_WIDTH_3_COLS}px)`);
  const { auth } = useAuth();
  // ============================================================
  // NEW - Role-based Permission System
  // See: src/common/utility/roleController.js
  // ============================================================
  const roleController = useRoleController();
  const permissions = usePermissions();
  
  // ============================================================
  // NEW - Role-based elite user check
  // See: src/common/utility/roleController.js
  // ============================================================
  const isEliteUser = permissions.isEliteUser();

  
  const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });
  const { open, msg,severity } = msgState;

  /**
 * autoclosing of the snackbar msg bar 
 */ 
  const handleClose = (event, reason) => {
    setMsgState({...msgState,open:false});
};

  useEffect(()=>{
    console.log("handlechange RIght panel props.showLive=",props.showLive);
    if(props.showLive==false){
      setValue(false);
    }
  },[props.showLive])

  useEffect(()=>{
    console.log("handlechange Toggle live");
      setValue(false);
    
  },[props.toggleLiveButton])

  useEffect(()=>{
    console.log("handlechange Toggle live",props.chartScreenType);
    setScreenId(props.chartScreenType);
    if(props.chartScreenType!=CHART_SCREEN_TYPE.FULL_CHART){
      setValue(false);
    }
    
  },[props.chartScreenType])

  const handleChange = (event, newValue) => {
    console.log("Newvalue=",newValue)
    if(props.chartScreenType==CHART_SCREEN_TYPE.FULL_CHART || props.chartScreenType == CHART_SCREEN_TYPE.TWO_COLUMNS || props.chartScreenType == CHART_SCREEN_TYPE.TWO_ROWS || props.chartScreenType == CHART_SCREEN_TYPE.GRID){
      setValue(newValue);
    if(newValue==0 && value!==0){
      // setValue(newValue);
      props.openLivePanel(true)
    }
    else if(newValue==1){
      // setValue(newValue);
      props.toggleWatchlist();
    }  else{ 
      props.closeModal();
      // props.openLivePanel(false)
      }
     
    }else{
      console.log("live panelhandleChange newValue= ",newValue)
      // if(newValue!=0)
      //   props.openLivePanel(false)

        // props.closeModal();
      
    if(newValue==0){
      setMsgState({ open: true, msg: TEXT_MSGS.LIVE_PANEL_NOT_SUPPORTED, severity: "info" });
    }
    else if(newValue==1){
      setMsgState({ open: true, msg: TEXT_MSGS.WATCHLIST_PANEL_NOT_SUPPORTED, severity: "info" });
    }
  }
}

  // const handleChange = (event, newValue) => {
  
  //   console.log("handlechange newValue=",newValue)
  //   if(props.chartScreenType==CHART_SCREEN_TYPE.FULL_CHART){
  //     console.log("handlechange newValue 2=",newValue)
  //   setValue(newValue);
    

  //   if(newValue==0)
  //     props.openLivePanel(true)
  //   }else{
  //     console.log("handlechange else resetrightpanel called=",newValue)
  //     if(newValue!=0)
  //       // props.openLivePanel(false)
  //       console.log("handlechange resetrightpanel called=",newValue)
  //       props.resetRightPanel();
      
  //   }
  // };

  

  const handleScreenChange = (event, newValue) => {
    // console.log("Prouser=",props.proUser)
    if(props.proUser){
      if(matches || newValue==0){
        if(newValue>3 && !matchesBigscreen){
          setMsgState({open:true,msg:TEXT_MSGS.MULTICHART_3_COLS_NOT_SUPPORTED,severity:"warning"});
          return;
        }

        setScreenId(newValue);
        props.setChartScreenType(newValue,true)
      }else if(newValue>0){
        setMsgState({open:true,msg:TEXT_MSGS.MULTICHART_NOT_SUPPORTED,severity:"warning"});
      }
      
    }else{
      props.openSubscribeModal();
    }
  };

  const isMPOnlyChart=()=>{
    //globalBookmarkData
    // console.log("isMPOnlyChart=",props.globalBookmarkData,props.savedData,props.savedData.type,props.savedData.data[0].type,props.isGlobalBookmark)
    if(!props.isGlobalBookmark && props.savedData && props.savedData.type==CHART_SCREEN_TYPE.FULL_CHART && props.savedData.data[0].type==CHART_TYPE.MARKET_PROFILE){
       console.log("isMPOnlyChart= Returning true")
      return true;
    }
    return false;
  }

  const handleGlobalBookmarkClick=()=>{
    if(!isMPOnlyChart())
    props.saveGlobalBookmark()
  }
  const handleWatchlistClick=()=>{

    props.toggleWatchlist()
  }
  // const liveClick=()=>{
  //   console.log("handlechange liveclick=",value)
  //   if(value==0){
  //     setValue(-1)
  //     props.closeModal();
  //   }else{
  //     setValue(0);
  //     props.openLivePanel(true);
  //   }
  // }
  const handleTabClick = (index) => {
    if(props.chartScreenType==CHART_SCREEN_TYPE.FULL_CHART || props.chartScreenType == CHART_SCREEN_TYPE.TWO_COLUMNS || props.chartScreenType == CHART_SCREEN_TYPE.TWO_ROWS || props.chartScreenType == CHART_SCREEN_TYPE.GRID){
    console.log("Newvalue handleTabClick index=",index)
    if(index==0 && value === index){
      props.closeModal();
    }
    else if (value === index) {
      setValue(false); // Deselect if clicked again
      props.toggleWatchlist();
      props.closeModal();
    } else {
      // setValue(index);
    }
    }
  };
  return (
    <>
    <Box
    sx={{flexGrow: 1, bgcolor: ` ${theme.palette.primaryTheme.shade01}`, display: 'flex',flexDirection:"column",
    width:"50px",
    position:"fixed",
    top:"var(--dashboard-content-top, 48px)",
    left:`calc(100% - 50px)`,
    pt: 0.5,
    height: `calc(100vh - var(--dashboard-content-top, 48px))`}}>
      <StyledTabs
        orientation="vertical"
        value={value === -1 || value === null ? false : value}
        onChange={handleChange}
        aria-label="icon position tabs example"
        scrollButtons={false}
      >
        {/* onClick={()=>liveClick()} */}
          <StyledTab disabled={!props.isLiveEnabled} icon={<FeedIcon />} label="Live"  onClick={() => handleTabClick(0)}/> 
          {props.isWatchlistAllowed ?
          <StyledTab  icon={<WatchLaterIcon />} label="Watchlist" onClick={() => handleTabClick(1)} /> 
          :
          <></>
        } 
          {/* <StyledTab icon={<NotificationAddIcon />}  label="Alerts" />
          <StyledTab icon={<DescriptionIcon />}  label="News" />
          <StyledTab icon={<NewspaperIcon />}  label="Notes" /> */}
      </StyledTabs>
     
        {isEliteUser ?
          <Box sx={{ display: 'flex', justifyContent: "center", alignItems: 'center', flexDirection: 'column',mt:2 }}>
            <Tooltip title={props.isGlobalBookmark ? "Save" : "Save As"}>
              <Save sx={{ ml: 0, cursor: 'pointer', color: (props.isGlobalBookmark && props.isDirty == false) || isMPOnlyChart() ? 'gray' : 'white' }} disabled={(props.isGlobalBookmark && props.isDirty == false) || (isMPOnlyChart())} onClick={() => handleGlobalBookmarkClick()}></Save>

            </Tooltip>
            <Typography sx={{ mt: 0.5, color: (props.isGlobalBookmark && props.isDirty == false) || isMPOnlyChart() ? 'gray' : 'white', textAlign: 'center', fontSize: '10px', textAlign: 'center' }}>{props.isGlobalBookmark ? "Save" : "Save As"}</Typography>
          </Box>

          :
          <></>}

        {/* {props.isWatchlistAllowed ?
          <Box sx={{ display: 'flex', justifyContent: "center", alignItems: 'center', flexDirection: 'column' }}>

            <Tooltip title={"Watchlist"}>
              <WatchLaterIcon sx={{ mt: 2, mb: 1, cursor: 'pointer', color: 'white' }} onClick={() => handleWatchlistClick()} />
            </Tooltip>
            <Typography sx={{ mt: 0.5, color: 'white', textAlign: 'center', fontSize: '10px', textAlign: 'center' }}>Watchlist</Typography>
          </Box>

          :
          <></>} */}
      <Divider orientation="vertical" sx={{width:"100%",height:'1px',marginBottom:"8px",marginTop:"8px",backgroundColor:'primaryTheme.shade03'}} />
      <StyledTabs
        orientation="vertical"
        value={screenId}
        onChange={handleScreenChange}
        aria-label="icon position tabs example"
        scrollButtons={false}
      >
          {/* <Tooltip title="Full Chart"> */}
          <StyledTabMultiChart icon={<CheckBoxOutlineBlankIcon />}  />
          {/* </Tooltip> */}
          <StyledTabMultiChart icon={<VerticalSplitIcon />}   />
          <StyledTabMultiChart icon={<HorizontalSplitIcon />}  />
          <StyledTabMultiChart icon={<GridViewIcon />}   />
          <StyledTabMultiChart icon={<ViewColumnIcon />}   />
          <StyledTabMultiChart icon={<ViewModuleIcon />}   />
      </StyledTabs>
    </Box>
    <AppErrorPopup
      open={open}
      message={msg}
      severity={severity}
      onClose={handleClose}
      showCloseX
    />
    {/* Legacy snackbar (replaced by AppErrorPopup)
    <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}}  open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} >
      <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
         {msg}
       </Alert>
    </Snackbar>
    */}  
    </>
  );
}

